import { useEffect, useState } from "react";

const DEFAULT_QUERY = "(max-width: 768px)";

/**
 * Match a CSS media query and keep the result in sync.
 * @param {string} [query]
 * @returns {boolean}
 */
export default function useIsMobile(query = DEFAULT_QUERY) {
	const [matches, setMatches] = useState(() => {
		if (typeof window === "undefined" || !window.matchMedia) {
			return false;
		}
		return window.matchMedia(query).matches;
	});

	useEffect(() => {
		if (typeof window === "undefined" || !window.matchMedia) {
			return undefined;
		}
		const media = window.matchMedia(query);
		const onChange = (event) => setMatches(event.matches);
		setMatches(media.matches);
		if (media.addEventListener) {
			media.addEventListener("change", onChange);
			return () => media.removeEventListener("change", onChange);
		}
		media.addListener(onChange);
		return () => media.removeListener(onChange);
	}, [query]);

	return matches;
}
